import {useEffect, useState} from "react";
import {useDispatch} from "react-redux";
import {API, Endpoints, Team} from "@brg/api";

import {ILMSModuleInfo} from "../../constants/ILMS";
import {clearLMSModule, setLMSModule} from "../../reducers/LMSSlice";

export const useGetLMSModule =
    (projectId: string, additionalInfo: any, disabled?: boolean): {LMSModuleInfo: ILMSModuleInfo | null, isLoading: boolean, error: boolean } => {
        const [resp, setResp] = useState<ILMSModuleInfo | null>(null);
        const [isLoading, setIsLoading] = useState(true);
        const [error, setError] = useState(false);
        const dispatch = useDispatch()

        const getComputedInfo = (info: ILMSModuleInfo) => {
            const buttons = info?.buttons

            if (!buttons?.length && !!additionalInfo) {
                const newButtons = [
                    ...(!!additionalInfo?.backLink ? [                    {
                        text: [
                            {lang: 'ru', name: 'Вернуться к списку модулей'},
                            {lang: 'en', name: 'Go back to the list of modules'}
                        ],
                        textMobile: [
                            {lang: 'ru', name: 'Вернуться к списку модулей'},
                            {lang: 'en', name: 'Go back to the list of modules'}
                        ],
                        href: additionalInfo?.backLink,
                        type: 'hollow'
                    }] :[]),
                    ...(!!additionalInfo?.contentLink ? [                    {
                        text: [
                            {lang: 'ru', name: 'Содержание курса'},
                            {lang: 'en', name: 'Course content'}
                        ],
                        textMobile: [
                            {lang: 'ru', name: 'Содержание курса'},
                            {lang: 'en', name: 'Course content'}
                        ],
                        href: additionalInfo?.contentLink,
                        type: 'hollow'
                    }] : []),

                    ...(additionalInfo && !!additionalInfo?.detailsLink ? [{
                        text: [
                            {lang: 'ru', name: 'Подробнее'},
                            {lang: 'en', name: 'Detailed'}
                        ],
                        textMobile: [
                            {lang: 'ru', name: 'Подробнее'},
                            {lang: 'en', name: 'Detailed'}
                        ],
                        href: additionalInfo?.detailsLink,
                        type: 'hollow'
                    }] : [])
                ]
                return {...info, buttons: newButtons}
            }

            return info;
        }

        useEffect(() => {
            if (projectId && !disabled) {
                setIsLoading(true);
                API.request()
                    .endpoint(Endpoints.geoGateway)
                    .url(`/api/LMS/GetModuleInfo`)
                    .addQuery('projectId', projectId)
                    .get()
                    .send()
                    .then((r: any) => r.json())
                    .then((r: any) => {
                        setResp(r);
                        setIsLoading(false);
                    }).catch((e: any) => {
                    setIsLoading(false);
                    setError(true);
                })
            }
        }, [projectId, disabled])

        useEffect(() => {
            if (!resp) return;

            dispatch(setLMSModule(getComputedInfo(resp)))

            return () => {
                dispatch(clearLMSModule())
            }
        }, [resp])

        return {LMSModuleInfo: resp, isLoading, error};
    }import {useEffect, useState} from "react";
import {useDispatch} from "react-redux";
import {API, Endpoints, Team} from "@brg/api";

import {ILMSModuleInfo} from "../../constants/ILMS";
import {clearLMSModule, setLMSModule} from "../../reducers/LMSSlice";

export const useGetLMSModule =
    (projectId: string, additionalInfo: any, disabled?: boolean): {LMSModuleInfo: ILMSModuleInfo | null, isLoading: boolean, error: boolean } => {
        const [resp, setResp] = useState<ILMSModuleInfo | null>(null);
        const [isLoading, setIsLoading] = useState(true);
        const [error, setError] = useState(false);
        const dispatch = useDispatch()

        const getComputedInfo = (info: ILMSModuleInfo) => {
            const buttons = info?.buttons

            if (!buttons?.length && !!additionalInfo) {
                const newButtons = [
                    ...(!!additionalInfo?.backLink ? [                    {
                        text: [
                            {lang: 'ru', name: 'Вернуться к списку модулей'},
                            {lang: 'en', name: 'Go back to the list of modules'}
                        ],
                        textMobile: [
                            {lang: 'ru', name: 'Вернуться к списку модулей'},
                            {lang: 'en', name: 'Go back to the list of modules'}
                        ],
                        href: additionalInfo?.backLink,
                        type: 'hollow'
                    }] :[]),
                    ...(!!additionalInfo?.contentLink ? [                    {
                        text: [
                            {lang: 'ru', name: 'Содержание курса'},
                            {lang: 'en', name: 'Course content'}
                        ],
                        textMobile: [
                            {lang: 'ru', name: 'Содержание курса'},
                            {lang: 'en', name: 'Course content'}
                        ],
                        href: additionalInfo?.contentLink,
                        type: 'hollow'
                    }] : []),

                    ...(additionalInfo && !!additionalInfo?.detailsLink ? [{
                        text: [
                            {lang: 'ru', name: 'Подробнее'},
                            {lang: 'en', name: 'Detailed'}
                        ],
                        textMobile: [
                            {lang: 'ru', name: 'Подробнее'},
                            {lang: 'en', name: 'Detailed'}
                        ],
                        href: additionalInfo?.detailsLink,
                        type: 'hollow'
                    }] : [])
                ]
                return {...info, buttons: newButtons}
            }

            return info;
        }

        useEffect(() => {
            if (projectId && !disabled) {
                setIsLoading(true);
                API.request()
                    .endpoint(Endpoints.geoGateway)
                    .url(`/api/LMS/GetModuleInfo`)
                    .addQuery('projectId', projectId)
                    .get()
                    .send()
                    .then((r: any) => r.json())
                    .then((r: any) => {
                        setResp(r);
                        setIsLoading(false);
                    }).catch((e: any) => {
                    setIsLoading(false);
                    setError(true);
                })
            }
        }, [projectId, disabled])

        useEffect(() => {
            if (!resp) return;

            dispatch(setLMSModule(getComputedInfo(resp)))

            return () => {
                dispatch(clearLMSModule())
            }
        }, [resp])

        return {LMSModuleInfo: resp, isLoading, error};
    }